module.exports = " <router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/registration/registration.component.html
// module id = ./src/app/registration/registration.component.html
// module chunks = main